import { useMemo } from 'react';

import { Button } from '@/components/Button';
import { ButtonWrapper, StyledStepperItem, StyledStepperContainer } from '@/components/ItineraryStepper/styles';
import { Paragraph } from '@/components/Paragraph';
import { useItineraryContext } from '@/context/ItineraryContext';
import { useDeviceBreakpoints } from '@/hooks/useDeviceBreakpoints';
import { useItineraryNavigation } from '@/hooks/useItineraryNavigation';

export function ItineraryStepper() {
  const { data } = useItineraryContext();
  const { isMobile, isTabletOrSmaller } = useDeviceBreakpoints();
  const navigation = useItineraryNavigation();

  const formattedItineraryPrice = useMemo(() => {
    if (!data) return null;

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(data?.price);
  }, [data]);

  const buttonSize = isTabletOrSmaller ? 'small' : 'medium';

  return (
    <StyledStepperContainer>
      {!isMobile && (
        <StyledStepperItem>
          <Paragraph size="sm" color="primary">
            Your trip goes to
          </Paragraph>
          <Paragraph size="xl">{data?.Destination.name}</Paragraph>
        </StyledStepperItem>
      )}
      {!isTabletOrSmaller && (
        <StyledStepperItem>
          <Paragraph size="sm" color="primary">
            Number of days
          </Paragraph>
          <Paragraph size="xl">{data?.duration} days</Paragraph>
        </StyledStepperItem>
      )}
      <StyledStepperItem>
        <Paragraph size="sm" color="primary">
          Total price
        </Paragraph>
        <Paragraph size="xl">{formattedItineraryPrice}</Paragraph>
      </StyledStepperItem>
      <ButtonWrapper>
        {!navigation.isFirstStep && (
          <Button variant="tertiary" size={buttonSize} onClick={navigation.back}>
            Back
          </Button>
        )}
        {!navigation.isLastStep && (
          <Button variant="secondary" size={buttonSize} onClick={navigation.next}>
            Next step
          </Button>
        )}
      </ButtonWrapper>
    </StyledStepperContainer>
  );
}
